import React, { useEffect, useState } from "react";
import AboutUs from "../components/AboutUs";
import AboutLegacy from "../components/AboutLegacy";
import Testimonial from "../components/Testimonial";
import LatestNews from "../components/LatestNews";
import { fetchAboutPage } from "../api/aboutPage";
import { fetchBlogsPage } from "../api/blogsPage";
import { useHomePage } from "../context/HomePageContext";

const AboutPage = () => {
  const { setContact } = useHomePage();
  const [about, setAbout] = useState(null);
  const [testimonials, setTestimonials] = useState([]);
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const loadAboutPage = async () => {
      try {
        const [aboutData, blogsData] = await Promise.all([
          fetchAboutPage(),
          fetchBlogsPage(),
        ]);
        if (!isMounted) return;

        setAbout(aboutData.about);
        setTestimonials(aboutData.testimonials);
        setBlogs(blogsData.blogs || []);
        if (aboutData.contact) {
          setContact(aboutData.contact);
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadAboutPage();

    return () => {
      isMounted = false;
    };
  }, [setContact]);

  return (
    <>
      <AboutUs about={about} showReadMore={false} />
      <AboutLegacy legacy={about?.legacy} />
      <Testimonial testimonials={testimonials} />
      <LatestNews newsItems={blogs} />
    </>
  );
};

export default AboutPage;
